import api from "./api";
import graphAPI from "./graphAPI";
import { GET_USER_INFO, ADD_FEEDBACK, WISE_AI_SEARCH } from "./query";

/** GET USER PROFILE INFO */
export const getUserInfo = (param) =>
  api.POST(null, { query: GET_USER_INFO(param) });
export const getUserProfile = (...props) => graphAPI.GET("/v1.0/me", ...props); // GRAPH EXPLORER
/** FEEDBACK */
export const addFeedback = (param) =>
  api.POST(null, { query: ADD_FEEDBACK(param) });
/** WISE AI SEARCH */
export const wiseAiSearch = (param) =>
  api.POST(null, { query: WISE_AI_SEARCH(param) });
